import script from "./AllowMicrophoneMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./AllowMicrophoneMessage.vue?vue&type=script&setup=true&lang=js"

import "./AllowMicrophoneMessage.vue?vue&type=style&index=0&id=3b1feab6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b1feab6"]])

export default __exports__